module.exports = __webpack_public_path__ + "static/media/photo221.5db1eafb.jpg";